import { NavLink, Outlet } from 'react-router-dom'
import { useAuth } from '../../hooks/useAuth'
import { usePermissions } from '../../hooks/usePermissions'
import ar from '../../locales/ar.json'
import { ClipboardList, BarChart2, Map, Users, Settings, LogOut } from 'lucide-react'

const t = ar.admin

const ROLE_LABELS = {
  admin:            'مدير النظام',
  reviewer:         'مراجع',
  readonly:         'قراءة فقط',
  organization:     'جهة توثيقية',
  legal_org:        'جهة قانونية',
  field_researcher: 'باحث ميداني',
}

export default function AdminLayout() {
  const { user, logout } = useAuth()
  const { isAdmin }      = usePermissions()

  const NAV_ITEMS = [
    { to: '/admin',          label: 'لوحة الإحصاء',  Icon: BarChart2,    end: true  },
    { to: '/admin/cases',    label: t.nav_cases,      Icon: ClipboardList, end: false },
    { to: '/admin/regions',  label: t.nav_regions,    Icon: Map,           end: false },
    // Only admins see user management and settings
    ...(isAdmin ? [
      { to: '/admin/users',    label: 'الحسابات',  Icon: Users,    end: false },
      { to: '/admin/settings', label: 'الإعدادات', Icon: Settings, end: false },
    ] : []),
  ]

  return (
    <div className="min-h-screen bg-stone-100 flex flex-col">
      {/* Top bar */}
      <header className="bg-primary-700 text-white px-4 py-2.5 flex items-center justify-between no-print">
        <div className="flex items-center gap-3">
          <img src="/logos/logo_icon.png" alt="" className="h-8 w-auto" />
          <span className="text-sm font-semibold hidden sm:block">{t.panelTitle}</span>
        </div>
        <div className="flex items-center gap-4">
          <span className="text-xs text-primary-200 hidden sm:block">
            {user?.display_name || user?.username} — {ROLE_LABELS[user?.role] || user?.role}
          </span>
          <button
            onClick={logout}
            className="text-xs bg-primary-600 hover:bg-primary-500 transition-colors rounded-lg px-3 py-1.5 flex items-center gap-1.5"
          >
            <LogOut size={13} />
            <span className="hidden sm:inline">{t.logout}</span>
          </button>
        </div>
      </header>

      <div className="flex flex-1">
        {/* Sidebar */}
        <nav className="w-48 bg-white border-l border-stone-200 flex-shrink-0 no-print">
          <ul className="mt-4 space-y-1 px-2">
            {NAV_ITEMS.map((item) => (
              <li key={item.to}>
                <NavLink
                  to={item.to}
                  end={item.end}
                  className={({ isActive }) =>
                    `flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-medium transition-colors ${
                      isActive
                        ? 'bg-primary-700 text-white'
                        : 'text-stone-600 hover:bg-stone-100'
                    }`
                  }
                >
                  <item.Icon size={16} strokeWidth={1.75} />
                  <span>{item.label}</span>
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>

        {/* Main content */}
        <main className="flex-1 overflow-auto p-4 sm:p-6">
          <Outlet />
        </main>
      </div>
    </div>
  )
}
